import { render, staticRenderFns } from "./VolumeButton.vue?vue&type=template&id=45fe1cf5&scoped=true&"
import script from "./VolumeButton.vue?vue&type=script&lang=js&"
export * from "./VolumeButton.vue?vue&type=script&lang=js&"
import style0 from "./VolumeButton.vue?vue&type=style&index=0&id=45fe1cf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe1cf5",
  null
  
)

export default component.exports